import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitonarmadaparikramacabbooking() {



const cardData = {
  keyword: "Mumbai to Narmada Parikrama Cab Booking",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Narmada Parikrama Cab Booking for travelers seeking a smooth and hassle-free journey between Maharashtra and Gujarat. Whether you are traveling for business, family visits, weekend trips, or group tours, our cab service ensures a safe and convenient ride with experienced drivers and well-maintained vehicles. We provide flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in long-distance highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Ahmedabad cab services.",

topPlaces: [
  {
    title: "Sabarmati Ashram",
    description:
      "Sabarmati Ashram, located on the banks of the Sabarmati River, is the historic residence of Mahatma Gandhi and a significant site in India’s freedom struggle. Visitors can explore the museum, Gandhi’s living quarters, and the peaceful ashram grounds. Traveling by cab ensures a comfortable journey from Mumbai, allowing ample time to learn about history and soak in the serene environment."
  },
  {
    title: "Akshardham Temple Ahmedabad",
    description:
      "Akshardham Temple in Ahmedabad is a magnificent spiritual and architectural landmark, featuring intricate carvings, gardens, and cultural exhibitions. Visitors can explore the temple complex, attend light and sound shows, and enjoy a tranquil atmosphere. A cab ride allows convenient access, making it easier to combine this visit with other sightseeing spots in Ahmedabad."
  },
  {
    title: "Kankaria Lake",
    description:
      "Kankaria Lake is a popular recreational area with boating, gardens, food stalls, and amusement facilities. Visitors can enjoy leisurely walks, photography, and fun activities with family and friends. Traveling by cab ensures hassle-free transport from Mumbai, providing flexibility to spend a full day exploring the lake and surrounding attractions."
  },
  {
    title: "Jama Masjid Ahmedabad",
    description:
      "Jama Masjid, built in the 15th century, is one of the largest and most impressive mosques in India. Visitors can admire its architecture, explore the inner courtyard, and capture photographs. Using a cab provides convenient access, making it easy to include this historic site in a sightseeing itinerary."
  },
  {
    title: "Sidi Saiyyed Mosque",
    description:
      "Sidi Saiyyed Mosque is famous for its intricately carved stone latticework, especially the iconic 'Tree of Life' jali. Visitors can explore the mosque’s architecture and take photographs. A cab service allows comfortable travel from Mumbai, giving ample time to appreciate this heritage site."
  },
  {
    title: "Adalaj Stepwell",
    description:
      "Adalaj Stepwell is an architectural marvel near Ahmedabad, known for its intricate carvings, stepwell design, and historic significance. Visitors can explore the multi-level structure, take photographs, and enjoy the cool atmosphere. Traveling by cab ensures convenient access and the flexibility to include it alongside other nearby attractions."
  },
  {
    title: "Calico Museum of Textiles",
    description:
      "Calico Museum of Textiles showcases rare and exquisite Indian fabrics, weaving techniques, and textile history. Visitors can enjoy guided tours, photography (where permitted), and cultural insights. A cab ride provides easy and comfortable travel from Mumbai, making it suitable for a half-day or full-day museum visit."
  },
  {
    title: "Science City Ahmedabad",
    description:
      "Science City offers interactive exhibits, planetarium shows, and educational activities for families and students. Visitors can explore science galleries, attend live demonstrations, and engage in hands-on learning. Traveling by cab ensures convenient and comfortable access, allowing tourists to plan a full day of educational fun."
  },
  {
    title: "Law Garden Night Market",
    description:
      "Law Garden Night Market is a vibrant shopping area in Ahmedabad, offering handicrafts, textiles, souvenirs, and street food. Visitors can experience local culture, shop for unique items, and enjoy the lively atmosphere. A cab ride provides hassle-free transport, allowing seamless integration with sightseeing itineraries."
  },
  {
    title: "Vastrapur Lake",
    description:
      "Vastrapur Lake is a scenic spot ideal for evening walks, photography, and recreational activities. Visitors can enjoy boating, open-air events, and relaxation amidst nature. Traveling by cab ensures convenient access, giving tourists flexibility to include this tranquil destination in their Ahmedabad trip."
  }
],




services: [
{
name: "Mumbai to Ahmedabad Cab",
description: "Mumbai to Ahmedabad cab service provides comfortable and reliable long-distance travel between Mumbai and the major commercial city of Ahmedabad. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys along NH-48. Professional drivers with extensive route knowledge ensure safe and timely travel. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is ideal for business travel, family visits, and corporate trips. Spacious seating and air-conditioned interiors ensure relaxed travel throughout the journey. Flexible one-way and round-trip options allow convenient trip planning. Transparent pricing ensures a smooth and stress-free cab booking experience."
},
{
name: "Mumbai to Ahmedabad Taxi",
description: "Mumbai to Ahmedabad taxi service offers convenient transportation for travelers visiting Gujarat’s largest city. Comfortable AC vehicles ensure pleasant long-distance travel along well-connected highway routes. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travelers, families, and tourists planning intercity journeys. Clean interiors and spacious seating provide a comfortable travel experience. Flexible departure schedules allow easy trip planning. Reliable taxi services ensure safe and comfortable travel."
},
{
name: "Mumbai to Ahmedabad Cab Service",
description: "Mumbai to Ahmedabad cab service provides dependable intercity transportation for passengers traveling between Maharashtra and Gujarat. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating. Professional drivers ensure safe driving along the Mumbai–Ahmedabad highway corridor. Pickup services are available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel, family visits, and long-distance tourism. Spacious vehicles provide comfortable seating for extended journeys. Flexible booking options allow travelers to schedule trips conveniently. Transparent pricing ensures a reliable cab service."
},
{
name: "Mumbai to Ahmedabad Taxi Service",
description: "Mumbai to Ahmedabad taxi service offers efficient and comfortable road travel between two major business cities. Our fleet of AC vehicles ensures relaxed travel conditions throughout the journey. Skilled drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for corporate meetings, family visits, and tourism travel. Spacious seating ensures passenger comfort during long-distance journeys. Flexible booking options allow convenient scheduling. Affordable fares ensure smooth taxi travel."
},
{
name: "Cab from Mumbai to Ahmedabad",
description: "Cab from Mumbai to Ahmedabad offers private and comfortable transportation for passengers traveling between the two cities. Our AC vehicles ensure smooth highway journeys and pleasant travel experiences. Professional drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business travel, family trips, and long-distance journeys. Spacious interiors ensure relaxed seating for passengers. Flexible departure timing allows convenient trip planning. Reliable cab services ensure stress-free travel."
},
{
name: "Taxi from Mumbai to Ahmedabad",
description: "Taxi from Mumbai to Ahmedabad provides dependable transportation for travelers seeking comfortable road travel. AC vehicles ensure pleasant journeys across highways connecting the two cities. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and business travelers. Clean interiors and spacious seating ensure passenger comfort throughout the journey. Flexible scheduling options allow easy travel planning. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Ahmedabad Cab Booking",
description: "Mumbai to Ahmedabad cab booking allows travelers to reserve vehicles easily for long-distance intercity travel. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for business trips, family travel, and tourist visits. Flexible one-way and round-trip booking options are available. Reliable booking service ensures hassle-free travel planning."
},
{
name: "Mumbai to Ahmedabad Taxi Booking Online",
description: "Mumbai to Ahmedabad taxi booking online provides quick and convenient reservations for passengers planning interstate journeys. Instant booking confirmation helps travelers schedule trips easily. Comfortable AC vehicles ensure relaxed highway travel. Experienced drivers ensure safe and professional driving services. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, tourists, and corporate travelers. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Ahmedabad Cab Price",
description: "Mumbai to Ahmedabad cab price offers affordable and transparent travel options for passengers planning long-distance journeys. Clear pricing details allow travelers to understand the total trip cost before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for various travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Ahmedabad Taxi Fare",
description: "Mumbai to Ahmedabad taxi fare is calculated with transparent per-kilometer pricing to ensure clear travel costs. Passengers can choose vehicle types depending on comfort and budget preferences. Our AC vehicles ensure smooth highway travel between Mumbai and Ahmedabad. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for business travel and family trips. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Ahmedabad One Way Cab",
description: "Mumbai to Ahmedabad one way cab service is perfect for travelers who require drop service without paying return charges. This option helps reduce travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for long-distance highway travel. Professional drivers ensure safe driving and punctual arrival. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for corporate travel and personal visits. Flexible departure timing allows convenient scheduling. Reliable one-way cab service ensures affordable travel."
},
{
name: "Mumbai to Ahmedabad Round Trip Taxi",
description: "Mumbai to Ahmedabad round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return timing allows travelers to complete business meetings or sightseeing comfortably. Comfortable AC vehicles ensure relaxed travel throughout the journey. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for corporate travel, tourism, and family visits. Spacious vehicles ensure comfortable travel for groups. Reliable round-trip taxi service ensures smooth travel planning."
},
{
name: "Mumbai to Ahmedabad Innova Cab",
description: "Mumbai to Ahmedabad Innova cab service provides spacious and comfortable travel for families and group travelers. The premium MPV offers ample seating space and luggage capacity for long-distance journeys. AC interiors ensure pleasant travel conditions throughout the trip. Experienced drivers ensure safe highway driving along the Mumbai–Ahmedabad route. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for corporate teams and family travel. Comfortable seating ensures relaxed travel for passengers. Reliable Innova cab service ensures convenient intercity travel."
}
],

tableData: [
["Mumbai to Ahmedabad Cab","Mumbai to Ahmedabad Taxi"],
["Mumbai to Ahmedabad Cab Service","Mumbai to Ahmedabad Taxi Service"],
["Cab from Mumbai to Ahmedabad","Taxi from Mumbai to Ahmedabad"],
["Mumbai to Ahmedabad Cab Booking","Mumbai to Ahmedabad Taxi Booking Online"],
["Mumbai to Ahmedabad Cab Price","Mumbai to Ahmedabad Taxi Fare"],
["Mumbai to Ahmedabad One Way Cab","Mumbai to Ahmedabad Round Trip Taxi"],
["Mumbai to Ahmedabad Innova Cab","Best Cab Mumbai to Ahmedabad"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced with the long-distance Mumbai to Ahmedabad highway route via NH48. They understand traffic patterns, toll plazas, and the safest driving practices to ensure a smooth and comfortable journey between Maharashtra and Gujarat."
  },
  {
    WhyChooseheading: "Transparent Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Ahmedabad cab bookings. We clearly explain per-kilometer fares, toll charges, and travel packages before booking so customers never face hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you want to travel overnight, early morning, or during the day, Omshree Cabs provides 24/7 cab booking and customer support for your Mumbai to Ahmedabad journey."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures a comfortable and relaxing ride for long-distance travel."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible travel plans including one-way cabs, round trips, and multi-day travel packages. Travelers can customize their trip schedule according to their travel needs."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Ahmedabad begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Intercity Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Ahmedabad trips. Our punctual service, professional drivers, and comfortable vehicles ensure a smooth and reliable intercity travel experience."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Ahmedabad by cab?", answer: "The distance from Mumbai to Ahmedabad is approximately 525 km and the journey usually takes around 9–10 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Ahmedabad cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Ahmedabad." },
  { question: "Which vehicles are available for Mumbai to Ahmedabad travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Ahmedabad cab bookings." },
  { question: "Can we stop during the journey for meals or rest?", answer: "Yes, passengers can request stops during the journey for food, refreshments, or rest breaks." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you offer overnight travel from Mumbai to Ahmedabad?", answer: "Yes, many travelers prefer overnight cab journeys and we provide safe night travel with experienced drivers." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide corporate travel services to Ahmedabad?", answer: "Yes, Omshree Cabs also provides corporate and business travel services for Mumbai to Ahmedabad routes." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Patel",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Ahmedabad trip. The driver was very professional and the car was clean and comfortable for the long journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Shah",
    feedback:
      "Our family journey from Mumbai to Ahmedabad with Omshree Cabs was smooth and stress-free. On-time pickup and transparent pricing made the trip excellent.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Narmada Parikrama Cab Booking",
  "description": "Book Mumbai to Narmada Parikrama Cab with Omshree Cab for comfortable pilgrimage travel. Reliable taxi service for Narmada Parikrama, Omkareshwar, Maheshwar, and other temple tours. Affordable cab packages, easy online booking, and safe travel for your Narmada yatra from Mumbai.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1700"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Mumbai to Narmada Parikrama Cab Booking | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Narmada Parikrama Cab with Omshree Cab for pilgrimage tours. Taxi service from Mumbai to Narmada, Omkareshwar, Maheshwar, and temple visits. Affordable fares and easy online cab booking for Narmada yatra." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitonarmadaparikramacabbooking;